import React, { Component } from 'react';

//components
import Icon from '../atoms/Icon';
import TextParagraph from '../atoms/TextParagraph';

//Returning the component
class SocialShare extends Component {
	render() {
		return (

			<div className={`socialShare ${this.props.classType}`}>
				<TextParagraph text={this.props.textParagraph} />
				<a href="https://fb.me/frankiecms" target="_blank" rel="noopener noreferrer"><Icon classType="fa-facebook-square fa-2x color-facebook" /></a>
				<a href="#link"><Icon classType="fa-linkedin-square fa-2x color-linkedin" /></a>
				<a href="#link"><Icon classType="fa-twitter-square fa-2x color-twitter" /></a>
			</div>
		)
	}
}


export default SocialShare;


// WEBPACK FOOTER //
// ./src/redux/components/molecules/SocialShare.jsx